var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMbcpLogo = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m47.047 41.88-3.003-22.338c-.094-1.03-.214-2.795-.216-2.813l-.022-.315h-6.575l-.34.042v.339c0 .89-.3 1.753-.66 2.707l-7.266 18.527-8.246-19.321c-3.063-7.082-7.353-9.043-9.602-9.583-3.245-.78-5.283-.1-5.283-.1.028 0 2.228-.106 4.102 1.253 3.395 2.461 3.606 5.663 3.053 9.798l-2.714 20.067c-.36 2.424-1.084 6.457-1.09 6.497l-.072.4h4.62l.023-.312c.002-.032.25-3.118.607-5.855L16.8 22.534l8.176 19.38c1.135 2.654 1.824 3.907 4.122 5.648l.357.271 9.883-25.237 2.437 20.59c.148 1.525.258 3.512.26 3.532l.018.32h5.782l-.066-.396c-.004-.026-.446-2.655-.72-4.763l-.001.002Z",
    fill: "#D1005D"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMbcpLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mbcpLogo.d6c230ed6532750f63d39750b9a10ae1.svg";